<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="false"
  class="production-summary"
>
  <div class="wrapper--spacing-all">
    <h5 class="text--h5">{{ 'dairyresults.production.productsummary-header' | translate }}</h5>
    <div class="flex--justify-space-between">
      <div class="flex--responsive-gt-sm flex--gutter flex--align-center delivery-location-summary">
        <div class="spacing--margin-horizontal spacing--margin-half-bottom">
          <div class="text--label">{{ 'dairyresults.production.date' | translate }}</div>
          <div class="flex flex--align-center">
            {{ (selectedDate | date: 'dd-MM-yyyy') || '-' }}
          </div>
        </div>
        <div class="spacing--margin-horizontal spacing--margin-half-bottom">
          <div class="text--label">{{ 'dairyresults.production.number-of-cows' | translate }}</div>
          <div class="flex flex--align-center">
            {{ selectedProduction?.lactatingCows + selectedProduction?.dryCows || '-' }}
          </div>
        </div>
        <div class="spacing--margin-horizontal spacing--margin-half-bottom">
          <div class="text--label">
            {{ 'dairyresults.production.number-milk-giving' | translate }}
          </div>
          <div class="flex flex--align-center">{{ selectedProduction?.lactatingCows || '-' }}</div>
        </div>
        <div class="spacing--margin-horizontal spacing--margin-half-bottom">
          <div class="text--label">
            {{ 'dairyresults.production.number-of-dry-cows' | translate }}
          </div>
          <div class="flex flex--align-center">{{ selectedProduction?.dryCows || '-' }}</div>
        </div>
        <div class="spacing--margin-horizontal spacing--margin-half-bottom">
          <div class="text--label">
            {{ 'dairyresults.production.number-of-measured-cows' | translate }}
          </div>
          <div class="flex flex--align-center">{{ selectedProduction?.cowsMeasured || '-' }}</div>
        </div>
      </div>
      <div class="flex flex--align-center">
        <app-production-picker
          (productionChanged)="onProductionChanged($event)"
        ></app-production-picker>
      </div>
    </div>

    @if (hasData()) {
      <div class="flex__child--auto">
        <div class="table-desktop">
          <table
            mat-table
            #table
            [dataSource]="dataSource"
            class="table-desktop__table--alternate-rows cust-table"
          >
            @for (column of superHeaders(); track column; let colIndex = $index) {
              <ng-container matColumnDef="{{ column }}">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  [attr.colspan]="superHeaderSettings[colIndex].colSpan"
                  class="cust-table__super-header cust-background"
                  [class]="{ 'cust-table__flagpole': superHeaderSettings[colIndex].flag }"
                >
                  {{ superHeaderSettings[colIndex].label | translate }}
                </th>
              </ng-container>
            }
            @for (column of columnIds(); track column; let colIndex = $index) {
              <ng-container matColumnDef="{{ column }}">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  [class]="{ 'cust-table__flagpole': columnSettings[colIndex].flag }"
                >
                  @if (columnSettings[colIndex].subLabel) {
                    <div>
                      <div class="flex--column">
                        <div>
                          {{ columnSettings[colIndex].label | translate }}
                        </div>
                        <div>
                          {{ columnSettings[colIndex].subLabel | translate }}
                        </div>
                      </div>
                    </div>
                  }
                  @if (!columnSettings[colIndex].subLabel) {
                    <div>
                      {{ columnSettings[colIndex].label | translate }}
                    </div>
                  }
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  [class]="{
                    'cust-table__flagpole': columnSettings[colIndex].flag,
                    'mat-column-number': colIndex > 0,
                  }"
                >
                  @if (columnSettings[colIndex].format) {
                    <div>
                      {{ row[column] | number: columnSettings[colIndex].format }}
                    </div>
                  }
                  @if (!columnSettings[colIndex].format) {
                    <div>{{ row[column] }}</div>
                  }
                </td>
                <td
                  mat-footer-cell
                  *matFooterCellDef="let row"
                  class="mat-column-number"
                  [class]="{
                    'cust-table__flagpole': columnSettings[colIndex].flag,
                    'mat-column-number': colIndex > 0,
                  }"
                >
                  @if (columnSettings[colIndex].format) {
                    <div>
                      {{ footer[column] | number: columnSettings[colIndex].format }}
                    </div>
                  }
                  @if (!columnSettings[colIndex].format) {
                    <div>{{ footer[column] }}</div>
                  }
                </td>
              </ng-container>
            }
            <tr
              mat-header-row
              *matHeaderRowDef="superHeader"
              class="ration-summary-table__table--header-1"
            ></tr>
            <tr mat-header-row *matHeaderRowDef="columnIds()"></tr>
            <tr mat-row *matRowDef="let row; columns: columnIds()"></tr>
            <tr mat-footer-row *matFooterRowDef="columnIds()"></tr>
          </table>
        </div>
      </div>
    }

    <agr-notification-empty
      [isEmpty]="!hasData()"
      [emptyTitle]="'no_items' | translate"
      emptyImage="/assets/images/no-items.png"
      class="complete__notification-empty"
    >
    </agr-notification-empty>

    <app-attention-summary></app-attention-summary>
  </div>
</agr-page-toolbar>
